<script setup>
defineProps({
    image: {
        type: String,
        default: null,
    },
    title: {
        type: String,
        required: true,
    },
    method: {
        type: String,
        required: true,
    },
    expectations: {
        type: String,
        required: true,
    },
    reality: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div class="flex flex-col text-left">
        <!-- Image -->
        <div class="relative w-full aspect-[4/3] rounded-2xl overflow-hidden mb-8 bg-gray-800 border border-white/5">
            <img v-if="image" :src="image" :alt="title"
                class="object-cover w-full h-full hover:scale-105 transition-transform duration-500" />
            <div v-else class="w-full h-full flex items-center justify-center text-gray-600">Image</div>
        </div>

        <!-- Title & Icon -->
        <div class="flex items-center space-x-3 mb-6 min-h-[8rem]">
            <div class="flex-shrink-0 text-pink-500">
                <slot name="icon">
                    <!-- Default Icon if none provided -->
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </slot>
            </div>
            <h3 class="text-xl font-bold text-white">{{ title }}</h3>
        </div>

        <!-- Content Blocks -->
        <div class="space-y-6">
            <div>
                <h4 class="text-white font-bold text-base mb-1">{{ $t('landingPage.v2.training.labels.method') }}</h4>
                <p class="text-gray-400 text-sm leading-relaxed">{{ method }}</p>
            </div>

            <div>
                <h4 class="text-white font-bold text-base mb-1">{{ $t('landingPage.v2.training.labels.expectations') }}
                </h4>
                <p class="text-gray-400 text-sm leading-relaxed">{{ expectations }}</p>
            </div>

            <div>
                <h4 class="text-white font-bold text-base mb-1">{{ $t('landingPage.v2.training.labels.reality') }}</h4>
                <p class="text-gray-400 text-sm leading-relaxed">{{ reality }}</p>
            </div>
        </div>
    </div>
</template>
